// copies a string to clipboard for legacy browsers
const fallbackCopyToClipboard = (str = '') => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected =
    document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0)
      : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
};

// copies a string to clipboard
const copyToClipboard = (str = '') => {
  if (!navigator.clipboard) {
    fallbackCopyToClipboard(str);
    return;
  }
  navigator.clipboard.writeText(str);
};

export default copyToClipboard;
